import jQuery from 'jquery';
let $ = jQuery;
import __extends from "LIBS/extend.js";

import "LIBS/jquery.showhtml.js";
import "LIBS/jquery.placeholder.js";

// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.GiftOptionsModal
*
* Encapsulates the functionality of a modal dialog 
**/
HSN.GiftOptionsModal = (function (parent) {
    __extends(GiftOptionsModal, parent);

    function GiftOptionsModal() {
        var modal = GiftOptionsModal.__super__.constructor.call(this);

        this.Close.off();//remove existing handler, have our own

        eventHandlers(this);

        return modal;
    }
    function eventHandlers(modal) {
        $(modal.Close).on('click', function (e) {
            closeModal(modal);
        });
            
    }
    function closeModal(modal) {
        modal.Hide();
        window.location.reload();
    }

    /**
    * HSN.GiftOptionsModal#Show() -> void
    *
    * Display the modal and load in the information.
    **/
    GiftOptionsModal.prototype._show = function (bagItemId, bagIdentity) {
        var scope = this;
        scope.AddLoadingSpinner();
        $.ajax('/checkout/gift-options/' + bagItemId + '?bagIdentity=' + bagIdentity + '&t=' + new Date().getTime(),
            {
                context: this,
                dataType: 'html',
                success: function (data) {
                    scope.RemoveLoadingSpinner();
                    this.Content.showHtml(
                            data,
                            0,
                            function () {
                                scope.Center();
                                scope.Content.animate({ opacity: 1 });
                                //handle any tooltips loaded
                                if (!Modernizr.touchevents) {
                                    HSN.Tooltip(scope.Content.find('[data-tooltip]'));
                                }
                                var template = new HSN.Template.GiftOptions({
                                    application: HSN.Instance(),
                                    container: '.gift-options-container',
                                    isInModal: true
                                });
                                $('input, textarea', scope.Content).placeholder();
                            },
                            function () {

                            }
                    );
                },
                error: function () {
                    alert('Unfortunately there was an error attempting to load the content, please try again.');
                    scope.RemoveLoadingSpinner();
                    scope.Hide();
                }
            }
        );
    };

    return GiftOptionsModal;
})(HSN.Modal);



// WEBPACK FOOTER //
// ./assets/js/HSN/Modals/Checkout/GiftOptionsModal.js